import { Tabs, Tab } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/advise' },
  { label: 'Suppliers', path: '/advise/suppliers' },
  { label: 'Customer Profile', path: '/advise/customers' },
  { label: 'Engagements', path: '/advise/engagements' },
  { label: 'Reports', path: '/advise/reports' },
  { label: 'Tasks', path: '/advise/tasks' }
];

export const AdviseSubNav = () => {
  const location = useLocation();

  const currentTab = NAV_ITEMS.findIndex((item) =>
    item.path === '/advise' ? location.pathname === '/advise' : location.pathname.startsWith(item.path)
  );

  return (
    <Tabs
      value={currentTab === -1 ? false : currentTab}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        minHeight: 36,
        mb: 2,
        borderBottom: 1,
        borderColor: 'divider',
        '& .MuiTab-root': { minHeight: 36, py: 0.5, textTransform: 'none', fontSize: '0.825rem' }
      }}>
      {NAV_ITEMS.map((item) => (
        <Tab
          key={item.path}
          label={item.label}
          component={Link}
          to={item.path}
        />
      ))}
    </Tabs>
  );
};
